import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";

export interface TransactionDetailsDTO {
  id: string;
  studentId: string;
  studentEmail: string;
  studentName: string;
  student: {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    img_url: string;
    phone: string;
    country: string;
    password: string;
    confirmPassword: string;
    createdAt: string;
    updatedAt: string;
    status: string;
    cartId: string;
    lastCountry: string;
    lastVisited: string;
    birthDate: string;
    jobTitle: string;
    isBlocked: boolean;
  };
  merchant_order_id: string | null;
  paymob_order_id: string;
  paymob_txn_id: string;
  success: boolean;
  pending: boolean;
  payment_status: string | null;
  amount_cents: number;
  currency: string;
  source_type: string;
  source_sub_type: string;
  source_pan: string;
  acq_response_code: string;
  data_message: string;
  error_occured: boolean;
  item_types: string[];
  courses: Array<{
    id: string;
    name: string;
    description: string;
    part: string;
    InstructorId: string;
    img_url: string;
    num_hours: string;
    preview_video: string;
    createdAt: string;
    updatedAt: string;
    categoryId: string;
    actualPrice_egp: string;
    actualPrice_usd: string;
    discountPercentage: number;
    discountPrice_egp: string;
    discountPrice_usd: string;
    packageId: string;
    slug: string;
    isTrending: boolean;
    borchure_url: string;
    parentCourseId: string | null;
  }>;
  packages: Array<{
    id: string;
    name: string;
    description?: string;
    img_url?: string;
  }>;
  books: Array<{
    id: string;
    name: string;
    description?: string;
    img_url?: string;
  }>;
  raw_callback: any;
  createdAt: string;
}

export const getTransactionDetails = async (
  paymobOrderId: string
): Promise<{ data: TransactionDetailsDTO } | { error: ApiError }> => {
  try {
    const response = await axios.get(`/transaction/paymob/${paymobOrderId}`);
    return { data: response.data };
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};